import React from 'react';

import { Box, Link, Text } from '@opendoor/bricks-next';
import { motion } from 'framer-motion';

interface MenuLinkItemProps {
  href: string;
  name: string;
  analyticsName: string;
  isActive?: boolean;
  showOnTablet?: boolean;
  tabletDisplay?: string;
}

export const MenuLinkItem: React.FC<MenuLinkItemProps> = ({
  href,
  name,
  analyticsName,
  isActive,
  showOnTablet,
  tabletDisplay,
}) => {
  const displayValue = showOnTablet ? (['flex', null, tabletDisplay, 'none'] as any) : undefined;

  return (
    <Box
      tag={motion.li as any}
      marginBottom="$8x"
      display={displayValue}
      $largerThanSM={{ display: 'none' }}
    >
      <Link
        aria-current={isActive}
        href={href}
        aria-label="View link"
        analyticsName={analyticsName}
        display="inline-flex"
        alignItems="center"
        fontWeight="$medium"
      >
        <Text
          tag="span"
          typography="$subheaderMedium"
          fontWeight="$medium"
          $smallerThanLG={{ typography: '$subheaderXsmall' }}
        >
          {name}
        </Text>
      </Link>
    </Box>
  );
};
